// @atlas/contracts — a `identities` modul Zod-sémái
//
// A fájl CSAK sémákat tart (érték-szintű Zod-objektumok + a belőlük inferált típusok) — a ROUTE-ok
// egyetlen `atlasContract` objektum-literálban maradnak (`src/index.ts`), mert a ts-rest
// kontextus-inferenciája a lapos bővítésre érzékeny. A sémák mozgatása ezt NEM érinti: sima értékek.
import { z } from 'zod';
export const IdentitySchema = z.object({
    id: z.string(),
    email: z.string().nullable(),
    displayName: z.string().nullable(),
    type: z.string(),
    status: z.string(),
    createdAt: z.string(),
});
//# sourceMappingURL=schemas.js.map